module.exports = __webpack_public_path__ + "img/Trash_P.d2818870.png";